/** @jsx jsx */
// @ts-check
import { gql } from '@apollo/client';
import { Text } from '@bottlebooks/gatsby-design-system';
import { graphql } from 'gatsby';
import React from 'react';
import { jsx } from 'theme-ui';
import Flag from '../Flag/Flag';

/**
 *
 * @param {object} props
 * @param {object} props.brand
 * @param {React.ReactNode} [props.children]
 */
export default function BrandRegion({ brand, children, ...rest }) {
  if (children) {
    return (
      <Text variant="smallest" {...rest}>
        {children}
      </Text>
    );
  }
  return (
    <BrandRegion brand={brand} {...rest}>
      <DefaultContent brand={brand} />
    </BrandRegion>
  );
}

export function DefaultContent({ brand }) {
  if (!brand) return null;
  return (
    <React.Fragment>
      {/* We don't need to provide an alt text because we add the countryName directly next to the flag. */}
      <Flag country={brand.countryCode} alt="" />{' '}
      {[brand.countryName, brand.region, brand.city].filter(Boolean).join(', ')}
    </React.Fragment>
  );
}

export const fragment = graphql`
  fragment bb_BrandRegion on Bottlebooks_AbstractBrand {
    countryName: country
    countryCode: country(format: RAW)
    region
    city
  }
  fragment BrandRegion on AbstractBrand {
    countryName: country(full: true)
    countryCode: country(full: false)
    region
    city
  }
`;

export const BrandRegionFragment = gql`
  fragment BrandRegion on AbstractBrand {
    countryName: country(format: LOCALIZED)
    countryCode: country(format: RAW)
    region
    city
  }
`;
